import courierData from "./cargoData";

export const getcargo = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        data: courierData,
        total: courierData.length
      });
    }, 500);
  });
};

export const getCargoById = (id) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(courierData.find((item) => item.id === parseInt(id)));
    }, 300);
  });
};